// Round-trip serializer between editor script format and DSL.
// Editor format (see native/src/editor/ui/Project.js encodeStrip):
//   strip = [[blocktype, arg, dx, dy, innerStrip?], ...]
// DSL form (per script):
//   { trigger: {block, arg?}, blocks: [{block, arg?, body?}], terminator?: {block, arg?} }
// Positions (dx/dy) are layout-only and re-derived by the editor on load
// (Scripts.recreateStrip → layout); they are dropped from the DSL by design.

const TRIGGER_IDS = ['onflag', 'onmessage', 'onclick', 'ontouch'];
const TERMINATOR_IDS = ['endstack', 'forever', 'gotopage'];

function isAbsentArg (arg) {
    return arg === null || arg === undefined || arg === 'null';
}

function editorElemToDSLBlock (elem) {
    const blocktype = elem[0];
    const arg = elem[1];
    const out = {block: blocktype};
    if (!isAbsentArg(arg)) {
        out.arg = arg;
    }
    if (blocktype === 'repeat') {
        const inner = Array.isArray(elem[4]) ? elem[4] : [];
        out.body = inner.map(editorElemToDSLBlock);
    }
    return out;
}

function editorStripToScript (strip) {
    const dslBlocks = strip.map(editorElemToDSLBlock);
    const script = {};
    let bodyStart = 0;
    let bodyEnd = dslBlocks.length;

    if (dslBlocks.length > 0 && TRIGGER_IDS.indexOf(dslBlocks[0].block) > -1) {
        script.trigger = dslBlocks[0];
        bodyStart = 1;
    }
    if (bodyEnd > bodyStart) {
        const last = dslBlocks[bodyEnd - 1];
        if (last && TERMINATOR_IDS.indexOf(last.block) > -1) {
            script.terminator = last;
            bodyEnd -= 1;
        }
    }
    script.blocks = dslBlocks.slice(bodyStart, bodyEnd);
    return script;
}

function editorScriptsToDSL (scriptsArray, _vocabulary) {
    if (!Array.isArray(scriptsArray)) {
        return [];
    }
    const out = [];
    for (const strip of scriptsArray) {
        if (!Array.isArray(strip) || strip.length === 0) {
            continue;
        }
        out.push(editorStripToScript(strip));
    }
    return out;
}

function dslBlockToEditorElem (block) {
    const blocktype = block.block;
    const arg = Object.prototype.hasOwnProperty.call(block, 'arg') ? block.arg : 'null';
    const elem = [blocktype, arg, 0, 0];
    if (blocktype === 'repeat') {
        const body = Array.isArray(block.body) ? block.body : [];
        elem.push(body.map(dslBlockToEditorElem));
    }
    return elem;
}

function scriptToEditorStrip (script) {
    const out = [];
    if (script.trigger) {
        out.push(dslBlockToEditorElem(script.trigger));
    }
    if (Array.isArray(script.blocks)) {
        for (const b of script.blocks) {
            out.push(dslBlockToEditorElem(b));
        }
    }
    if (script.terminator) {
        out.push(dslBlockToEditorElem(script.terminator));
    }
    return out;
}

function dslToEditorScripts (dslScripts) {
    if (!Array.isArray(dslScripts)) {
        return [];
    }
    return dslScripts.map(scriptToEditorStrip);
}

module.exports = {
    editorScriptsToDSL,
    dslToEditorScripts,
    TRIGGER_IDS,
    TERMINATOR_IDS
};
